import * as actionTypes from "./actionTypes";

import { config } from "../../constants";
import { axiosApiInstance } from "../../axios";
import {
  clearDefaultLocationStorage,
  persistDefaultLocation,
  readDefaultLocationFromStorage,
} from "../../shared/defaultLocationStorage";
import {
  clearTenantStorage,
  persistTenant,
  readTenantFromStorage,
} from "../../shared/tenantStorage";
import { isInactiveTenantResponse } from "../../shared/tenantApiErrors";

import axios from "axios";

import { setFeatureFlags } from "./featureFlags";

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START,
  };
};

export const authSuccess = (authData) => {
  const user = authData.user ?? {};
  const token = authData.token;

  localStorage.setItem("authToken", token);
  localStorage.setItem("name", user.name ?? "");
  localStorage.setItem("email", user.email ?? "");
  localStorage.setItem("id", user.id ?? "");
  localStorage.setItem("user_type", user.user_type ?? "");

  persistTenant(authData.tenant ?? null);
  persistDefaultLocation(authData.default_location ?? null);
  setFeatureFlags();

  return {
    type: actionTypes.AUTH_SUCCESS,
    authToken: token,
    name: user.name ?? "",
    email: user.email ?? "",
    id: user.id ?? null,
    user_type: user.user_type ?? 0,
    tenant: authData.tenant ?? null,
    roles: authData.roles ?? [],
    permissions: authData.permissions ?? [],
    default_location: authData.default_location ?? null,
  };
};

export const updateAccountSuccess = (user) => {
  localStorage.setItem("name", user.name);
  localStorage.setItem("email", user.email);

  return {
    type: actionTypes.UPDATE_ACCOUNT_SUCCESS,
    name: user.name,
    email: user.email,
  };
};

export const updateTenantSuccess = (tenant) => {
  persistTenant(tenant);

  return {
    type: actionTypes.UPDATE_TENANT_SUCCESS,
    tenant,
  };
};

export const updateDefaultLocationSuccess = (defaultLocation) => {
  persistDefaultLocation(defaultLocation);

  return {
    type: actionTypes.UPDATE_DEFAULT_LOCATION_SUCCESS,
    default_location: defaultLocation ?? null,
  };
};

export const authFail = (error) => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error,
  };
};

export const requestFailed = (error) => {
  return {
    type: actionTypes.REQUEST_FAILED,
    error: error,
  };
};

export const logout = () => {
  clearTenantStorage();
  clearDefaultLocationStorage();
  localStorage.removeItem("authToken");
  localStorage.removeItem("name");
  localStorage.removeItem("email");
  localStorage.removeItem("id");
  localStorage.removeItem("user_type");
  localStorage.removeItem("qa");

  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};

export const checkAuthTimeout = (expirationDateout) => {
  //   return (dispatch) => {
  //     setTimeout(() => {
  //       dispatch(logout());
  //     }, expirationDateout * 1000);
  //   };
};

export const fetchSession = () => {
  return (dispatch) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      dispatch(logout());
      return Promise.resolve();
    }

    return axiosApiInstance
      .get("me", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        dispatch(
          authSuccess({
            token,
            user: response.data.user,
            tenant: response.data.tenant ?? null,
            roles: response.data.roles ?? [],
            permissions: response.data.permissions ?? [],
            default_location: response.data.default_location ?? null,
          }),
        );
      })
      .catch((err) => {
        if (isInactiveTenantResponse(err)) {
          alert(
            err.response?.data?.message ||
              "This company account is inactive. Please contact QA Trace support.",
          );
          dispatch(logout());
          return;
        }

        if (err.response?.status === 401) {
          dispatch(logout());
          return;
        }

        dispatch(
          authSuccess({
            token,
            user: {
              name: localStorage.getItem("name"),
              email: localStorage.getItem("email"),
              id: localStorage.getItem("id"),
              user_type: localStorage.getItem("user_type"),
            },
            tenant: readTenantFromStorage(),
            roles: [],
            permissions: [],
            default_location: readDefaultLocationFromStorage(),
          }),
        );
      });
  };
};

export const auth = (email, password) => {
  return (dispatch) => {
    dispatch(authStart());
    const payload = {
      email: email,
      password: password,
    };
    let url = config.url.API_URL + "login";

    axios
      .post(url, payload)
      .then((response) => {
        dispatch(
          authSuccess({
            token: response.data.token,
            user: response.data.user,
            tenant: response.data.tenant ?? null,
            default_location: response.data.default_location ?? null,
          }),
        );
      })
      .catch((err) => {
        dispatch(authFail(err.response));
      });
  };
};

export const authCheckState = () => {
  return (dispatch) => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      dispatch(logout());
      return;
    }

    dispatch(
      authSuccess({
        token: authToken,
        user: {
          name: localStorage.getItem("name"),
          email: localStorage.getItem("email"),
          id: localStorage.getItem("id"),
          user_type: localStorage.getItem("user_type"),
        },
        tenant: readTenantFromStorage(),
        roles: [],
        permissions: [],
        default_location: readDefaultLocationFromStorage(),
      }),
    );

    dispatch(fetchSession());
  };
};

export const updateAccountDetails = (payload) => {
  return (dispatch) => {
    dispatch(authStart());

    let url = config.url.API_URL + "users/" + localStorage.getItem("id");

    const headers = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("authToken"),
      },
    };

    axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(updateAccountSuccess(payload));
      })
      .catch((err) => {
        dispatch(authFail(err.response));
      });
  };
};
